import { create } from "zustand";
import { TokenPayload } from "../domain/helpers/TokenPayload";

interface LoginStore {
  user: TokenPayload | null;
  setUser: (user: TokenPayload | null) => void;
}

export const useUserStore = create<LoginStore>((set) => ({
  user: null,
  setUser: (user: TokenPayload | null) => set({ user }),
}));
